import { $isTextNode, type LexicalNode, type TextNode } from 'lexical'
import { getContractVariable } from '@super-mega/server/contracts/contract'
import { $createContractVariableNode } from '../contract-variable-node.ts'

function isPlainText(node: LexicalNode | null): node is TextNode {
  return $isTextNode(node) && node.isSimpleText() && !node.isTextEntity()
}

/** 合并同一行的文本片段识别占位符，保留占位符首字符及前后正文的格式。 */
export function $transformContractVariables(node: TextNode) {
  if (!isPlainText(node) || !node.isAttached() || node.isComposing()) {
    return
  }
  let first = node
  while (isPlainText(first.getPreviousSibling())) {
    first = first.getPreviousSibling() as TextNode
  }
  const run: TextNode[] = []
  let current: LexicalNode | null = first
  while (isPlainText(current)) {
    run.push(current)
    current = current.getNextSibling()
  }
  const text = run.map((item) => item.getTextContent()).join('')
  for (const match of text.matchAll(/\{\{\s*([\w.]+)\s*\}\}/g)) {
    const variable = getContractVariable(match[1])
    if (!variable) {
      continue
    }
    let offset = 0
    const end = match.index + match[0].length
    let inserted = false
    for (const item of run) {
      const length = item.getTextContentSize()
      const start = offset
      offset += length
      if (offset <= match.index || start >= end) {
        continue
      }
      const from = Math.max(0, match.index - start)
      const to = Math.min(length, end - start)
      const parts = item.splitText(from, to)
      const fragment = parts[from === 0 ? 0 : 1]
      if (!inserted) {
        fragment.replace($createContractVariableNode(variable).setFormat(item.getFormat()).setStyle(item.getStyle()))
        inserted = true
      } else {
        fragment.remove()
      }
    }
    // 替换会将相邻文本标记为 dirty，由 Lexical 的下一轮 transform 处理其余变量。
    return
  }
}
